import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Tooltip } from '@mui/material'
import GA4 from 'helpers/ga4'

const CopyButton = ({ content }: { content: string }) => {
  const [copied, setCopied] = useState(false)
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const handleCopy = async () => {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current)
    }
    try {
      await navigator.clipboard.writeText(content)
      GA4.sendEvent({ category: 'Chat Bot', action: 'Chat Bot Response Copied' })
      setCopied(true)
      setTooltipOpen(true)
      timeoutRef.current = setTimeout(() => {
        setTooltipOpen(false)
        setTimeout(() => setCopied(false), 200)
      }, 1000)
    } catch (err) {
      console.error('Failed to copy message to clipboard:', err)
    }
  }

  return (
    <Tooltip
      title={copied ? 'Copied!' : 'Copy response'}
      placement="top"
      open={tooltipOpen}
      onOpen={() => setTooltipOpen(true)}
      onClose={() => { if (!copied) setTooltipOpen(false) }}
    >
      <S.CopyButton type="button" onClick={handleCopy} aria-label="Copy response">
        <S.CopyIcon src="/img/copy.svg" alt="Copy" />
      </S.CopyButton>
    </Tooltip>
  )
}

export default CopyButton

const S = {
  CopyButton: styled.button`
    position: absolute;
    top: 6px;
    right: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    border: none;
    background: transparent;
    cursor: pointer;
    opacity: 0.6;
    border-radius: 4px;

    &:hover {
      opacity: 1;
    }
  `,
  CopyIcon: styled.img`
    width: 15px;
    height: 15px;
  `
}
